/**
 * Initializes ministry stats by moving stat containers into the correct position
 * within the card deck content area
 */
export function mergeMinistryStatsInit(): void {
  document.querySelectorAll('.widget-merge-ministry-stats').forEach((widget) => {
    const container = widget.querySelector('.section-card-deck .card .card-text .formatted-content')
    const stats = widget.nextElementSibling?.classList.contains('merge-stats-container')
      ? widget.nextElementSibling
      : widget.querySelector('.merge-stats-container')

    if (container && stats) {
      // Avoid inserting a parent into its descendant
      if (!stats.contains(container)) {
        // Place stats as the second-to-last element (before the last child)
        if (container.children.length >= 1) {
          const last = container.lastElementChild

          if (last && last !== stats) {
            const links = last.querySelector('a')
            const containsLinks = links?.classList.contains('btn')
            if (containsLinks) {
              container.insertBefore(stats, last)
            } else {
              container.appendChild(stats)
            }
          }
        } else {
          // If no children exist, just append
          container.appendChild(stats)
        }
      }
    }
  })
}
